import {Component, ViewChild} from '@angular/core';
import {NovoCompromissoComponent} from "../../componentes/novo-compromisso/novo-compromisso.component";
import {CalendarioComponent} from "../../../../../core/componentes/calendario/calendario.component";

@Component({
    selector: 'app-minha-agenda',
    templateUrl: './minha-agenda.component.html',
    styleUrl: './minha-agenda.component.css',
    standalone: false
})
export class MinhaAgendaComponent {
  @ViewChild(NovoCompromissoComponent) novoCompromissoComponente: NovoCompromissoComponent;
  @ViewChild(CalendarioComponent) calendarioComponente: CalendarioComponent;
  loading = false;

  abrirModal(data?: Date){
    this.novoCompromissoComponente.abrirModal(data);
  }

  atualizarListaDiario(){
    this.calendarioComponente.carregarDados();
  }

}
